const DEFAULT_PARAMS = {
	applicationId: 'cms_sandbox',
	timestamp: ''
}
const state = {}
const mutations = {}

const actions = {
	async GET ({ getters }, payload) {
		const url = payload.url
		let baseURL = payload.baseUrl || this._vm.BASE_URL
		const params = payload.params || {}
		const headers = payload.headers || {}
		Object.assign(params, Object.assign(DEFAULT_PARAMS, { timestamp: this._vm.$moment().unix() }))

		if (payload.ingoreBaseUrl) {
			baseURL = ''
		}
		return this._vm.$http({
			method: 'get',
			url,
			baseURL,
			params,
			headers
		})
	},
	async POST ({ getters }, payload) {
		const data = payload.data || {}
		const url = payload.url
		const headers = payload.headers || {}
		let baseURL = payload.baseUrl || this._vm.BASE_URL
		const params = payload.params || {}
		Object.assign(params, Object.assign(DEFAULT_PARAMS, { timestamp: this._vm.$moment().unix() }))
		// console.log(this._vm.getToken)

		if (payload.ingoreBaseUrl) {
			baseURL = ''
		}
		return this._vm.$http({
			method: 'post',
			url,
			data,
			baseURL,
			headers,
			params
		})
	},
	async PUT ({ getters }, payload) {
		const data = payload.data || {}
		const url = payload.url
		const headers = payload.headers || {}
		let baseURL = payload.baseUrl || this._vm.BASE_URL
		if (payload.ingoreBaseUrl) {
			baseURL = ''
		}
		const params = payload.params || {}
		Object.assign(params, Object.assign(DEFAULT_PARAMS, { timestamp: this._vm.$moment().unix() }))
		return this._vm.$http({
			method: 'put',
			url,
			data,
			baseURL,
			headers,
			params
		})
	},
	async PATCH ({ getters }, payload) {
		const data = payload.data || {}
		const url = payload.url
		let baseURL = payload.baseUrl || this._vm.BASE_URL
		const params = payload.params || {}
		Object.assign(params, Object.assign(DEFAULT_PARAMS, { timestamp: this._vm.$moment().unix() }))
		const headers = payload.headers || {}
		Object.assign(params, Object.assign(DEFAULT_PARAMS, { timestamp: this._vm.$moment().unix() }))

		if (payload.ingoreBaseUrl) {
			baseURL = ''
		}
		return this._vm.$http({
			method: 'patch',
			url,
			data,
			baseURL,
			headers,
			params
		})
	},
	async DELETE ({ getters }, payload) {
		const data = payload.data || {}
		const url = payload.url
		let baseURL = payload.baseUrl || this._vm.BASE_URL
		const params = payload.params || {}
		const headers = payload.headers || {'Content-Type': 'application/x-www-form-urlencoded'}
		Object.assign(params, Object.assign(DEFAULT_PARAMS, { timestamp: this._vm.$moment().unix() }))

		if (payload.ingoreBaseUrl) {
			baseURL = ''
		}
		return this._vm.$http({
			method: 'delete',
			url,
			data,
			baseURL,
			params,
			headers
		})
	}
}

const getters = {
	/* getAuthUrl: (state) => {
		return state.AUTH_URL
	},
	getBaseUrl: function (state) {
		return.BASE_URL
	},
	getApiBaseUrl: (state) => {
		return this._vm.API_BASE_URL
	},
	getCmsBaseUrl: (state) => {
		return this._vm.CMS_BASE_URL
	},
	getFileManager: (state) => {
		return this._vm.FILE_MANAGER
	},
	getUploadPath: (state) => {
		return this._vm.UPLOAD_PATH
	} */
}

export default {
	state,
	mutations,
	actions,
	getters
}
